import React from "react";
import "./styles.scss";
import useApp from "../../hooks/useApp";

const PoweredByLogo = ({ footerText, isHidePoweredBy }) => {
  const { tenantConfig, selectedLanguage } = useApp();
  if (
    tenantConfig?.powered_by?.title[selectedLanguage?.value] &&
    tenantConfig?.powered_by?.content.logo
  ) {
    return (
      <>
        <div className="powered-by-container">
          {!isHidePoweredBy && (
            <p className="powered-by-label">
              {tenantConfig?.powered_by?.title[selectedLanguage?.value]}
            </p>
          )}
          {!isHidePoweredBy && (
            <img
              src={`${tenantConfig?.powered_by.content.logo}`}
              alt="powered-by-logo"
              className="powered-by-logo"
            />
          )}
          {footerText && <p className="powered-by-footer-text">{footerText}</p>}
        </div>
      </>
    );
  } else {
    return (
      <div className="powered-by-container">
        {footerText && <p className="powered-by-footer-text">{footerText}</p>}
      </div>
    );
  }
};

export default PoweredByLogo;
